<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Staff Stock Logs</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">

                        <b>Vendor</b> <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense required class="mt-4" v-model="vendor" item-value="id"
                            :items="vendorlist" item-text="company_name" label="Vendor"
                            @change="getvendorshopfromvendor(vendor)" outlined />

                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="vendorshoplist.length > 0">
                        <b>Vendor Shop</b> <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense required class="mt-4" v-model="vendorshop" item-value="id"
                            :items="vendorshoplist" item-text="name" label="Vendor Shop" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="vendor && vendorshoplist.length > 0">
                        <b>Staff</b> <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense required class="mt-4" v-model="staff" item-value="id"
                            :items="stafflist" item-text="name" label="Staff Option" outlined />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="mt-10" v-if="vendor && vendorshoplist.length > 0">
                        <v-btn class="button" @click="getReport()" :loading="loader">Fetch
                            Report</v-btn>
                    </v-col>

                </v-row>

            </v-card>

            <!-- <span v-if="mainList != '' && mainList != null"> -->   
            <v-card v-if="getdatastaffstocklogslist.length > 0">
                <v-card-title>
                    <v-btn v-if="getdatastaffstocklogslist != '' && getdatastaffstocklogslist != null"
                        class="ml-2 mt-5 no-display" rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'InvoiceReport')" :loading="loader">
                        <v-icon color="success">mdi-export</v-icon>Export
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="getdatastaffstocklogslist.length > 0" :headers="headers1"
                    :items="getdatastaffstocklogslist" :search="search" class="elevation-1 mytable" id="my-table-id">                
                    <template v-slot:[`item.action`]="{ item }">                
                    <v-icon size="25" color="success" @click="openEditDialog(item)">
                        mdi-restore
                    </v-icon>
                </template>
                <template v-slot:[`item.size_label_type`]="{ item }">                
                    <div v-if="item.size_label_type != null">{{ item.size_label_type }}</div>
                    <div v-else>--</div>
                </template>
                <template v-slot:[`item.size_label`]="{ item }">                
                    <div v-if="item.size_label != null">{{ item.size_label }}</div>
                    <div v-else>--</div>
                </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="editDialog" max-width="900px">
            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Return Stock</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="editForm">
                        <v-row justify="center" class="mt-4">
                            <!-- Read-Only Fields -->
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.invvendor_name" readonly label="Vendor *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.vendor_shop" readonly label="Vendor Shop *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.item_category" readonly label="Item Category *"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="mt-4">
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.item_name" readonly label="Item Name *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.size_label_type" readonly label="Size Label Type *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.size_label" readonly label="Size Label *"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="mt-4">
                            <v-col cols="12" sm="3">
                                <v-autocomplete dense rounded v-model="selectedStock.academicYear" :items="ayList" item-text="ay" item-value="id" outlined persistent-hint hint="Please Select Academic Year" :rules="[v => !!v || 'Academic Year is required']">
                                    <template v-slot:label>
                                        <span>Academic Year *</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-autocomplete dense rounded v-model="selectedStock.staff" :items="stafflist" item-text="name" item-value="id" outlined persistent-hint hint="Please Select Staff" :rules="[v => !!v || 'Staff is required']">
                                    <template v-slot:label>
                                        <span>Staff *</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded v-model="selectedStock.returnDate" label='Return Date *' type="date" outlined :rules="[v => !!v || 'Date is required']">
                                    <template v-slot:label>
                                        <span>Return Date *</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded v-model="selectedStock.quantity" label="Return Quantity *" type="number" outlined :rules="[v => !!v || 'Quantity is required']">
                                    <template v-slot:label>
                                        <span>Return Quantity *</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="mt-4">
                            <v-col cols="12" sm="6">
                                <v-textarea dense rounded v-model="selectedStock.remark" label="Remark" outlined>
                                    <template v-slot:label>
                                        <span>Remark</span>
                                    </template>
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="editDialog = false">Cancel</v-btn>
                    <v-btn color="primary" :loading="loader" :disabled="!isFormValid" @click="saveReturnStock">Return Stock</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>




        </v-container>

    </div>

</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
    data: () => ({
        selectedStock: {},
        loader: false,
        snackbar_msg: "",
        search: "",
        basepath: null,
        staff: null,
        vendorshop: null,
        vendor: null,
        color: "",
        snackbar: false,
        overlay: false,
        vendorshoplist: [],
        vendorlist: [],
        stafflist: [],
        getdatastaffstocklogslist: [],
        ayList: [],
        editDialog: false,
        headers1: [
            {
                text: "Sr. No.",
                value: "srno",
            },
            {
                text: "Vendor",
                align: "center",
                value: "invvendor_name",
            },
            {
                text: "Vendor Shop",
                align: "center",
                value: "vendor_shop",
            },
            {
                text: "Item Category",
                align: "center",
                value: "item_category",
            },
            {
                text: "Item Name",
                align: "center",
                value: "item_name",
            },
            {
                text: "Size Label Type",
                align: "center",
                value: "size_label_type",
            },
            {
                text: "Size Label",
                align: "center",
                value: "size_label",
            },
            {
                text: "Standard",
                align: "center",
                value: "standard",
            },
            {
                text: "Academic Year",
                align: "center",
                value: "academicyear",
            },
            {
                text: "Transaction Type",
                align: "center",
                value: "transaction_type",
            },
            {
                text: "Transaction Date",
                align: "center",
                value: "transaction_date",
            },
            {
                text: "Quantity",
                align: "center",
                value: "quantity",
            },
            {
                text: "Remark",
                align: "center",
                value: "remark",
            },
            {
                text: "Action",
                align: "center",
                value: "action",
            },

        ],

    }),
    computed:{
        isFormValid() {
            return this.selectedStock.academicYear &&
                this.selectedStock.staff &&
                this.selectedStock.returnDate &&
                this.selectedStock.quantity > 0;
        },
    },
    methods: {

        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        openEditDialog(item) {
            this.selectedStock = {
                ...item,
                returnDate: new Date().toISOString().substr(0, 10) // Added return date for return mode
            };
            this.editDialog = true;
        },
        saveReturnStock() {
            // Prepare payload
            const payload = {
                ...this.selectedStock
            };
            this.overlay = true;
            this.loader = true;
            axios.post("/EduStore/saveReturnStock", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Stock Returned Successfully!");
                        this.editDialog = false;
                        this.getReport(); // Refresh stock data after saving
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        if (res.data.error_trace) {
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error saving stock:", error);
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.loader = false;
                    this.selectedStock.quantity = "";
                    this.selectedStock.remark = "";
                });
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        onLoad() {
            axios
                .post("/EduStore/getStaffStudentAyVendorlist")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.vendorlist = res.data.vendorlist;
                        this.ayList = res.data.ay_list || [];
                        this.stafflist = res.data.stafflist;


                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        getvendorshopfromvendor(vendor) {
            this.vendorshoplist = [];
            const data = {

                vendor: vendor,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getvendorshopfromvendor", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.vendorshoplist = res.data.vendorshoplist
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        getReport() {
            this.loader = true;
            this.getdatastaffstocklogslist = [];
            const data = {

                vendor: this.vendor,
                vendorshop: this.vendorshop,
                staff: this.staff
            };
            axios
                .post("/EduStore/fetchStaffStockLogs", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.getdatastaffstocklogslist = res.data.stock_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.msg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}
</style>
